import React, { useState, useEffect } from 'react';
import NodeTreeButton from './NodeTreeButton';
import {TextField, Box} from '@mui/material';
 
const NodeSelectInput = props => {
    const [value, setValue] = useState('');
    const [sketchJson, setSketchJson] = React.useState({});
    const [targetNode, setTargetNode] = React.useState(null);

    const findNodeRecur = (sketch_json, node_udid) => {
        if(sketch_json.do_objectID == node_udid){
          return sketch_json
        }
        for(let i=0;sketch_json.layers && i<sketch_json.layers.length;i++){
          let r = findNodeRecur(sketch_json.layers[i], node_udid)
          if(r)
            return r
        }
        return null
    }

    const findNodeRecurByName = (sketch_json, node_name) => {
        if(sketch_json.name == node_name){
          return sketch_json
        }
        for(let i=0;sketch_json.layers && i<sketch_json.layers.length;i++){
          let r = findNodeRecurByName(sketch_json.layers[i], node_name)
          if(r)
            return r
        }
        return null
    }

    useEffect(() => {
        if(props.value){
            setValue(props.value)
        } else {
            setValue('')
        }

        if(props.sketchJson && props.targetNode){
            let found = findNodeRecur(props.sketchJson, props.targetNode)
            // console.log('props.targetNode', props.targetNode, found, props.sketchJson)
            setSketchJson(found)
            setTargetNode(props.targetNode)
        } else {
            setSketchJson(props.sketchJson)
            setTargetNode(props.targetNode)
        }

    }, [props.value, props.sketchJson, props.targetNode])

    const handleValueChange = (newValue) => {
        if(props.onChange)
            props.onChange(newValue)
    }

    const handleNodeSelected = (udid, name) => {
        setValue(name)
        if(props.onChange)
            props.onChange(name)
    }
    return (
        <Box display="flex">
            <TextField label={props.label} value={value} onChange={(e)=>handleValueChange(e.target.value)} />
            <NodeTreeButton selectableJsonDepth={props.selectableJsonDepth} onSelected={handleNodeSelected} json={sketchJson} />
        </Box>
    );
};

export default NodeSelectInput;
